import FilterChiclets from "./FilterChiclets";

export default class MultiSelectCheckboxFilter {
  constructor(container, manager, chicletContainer = null) {
    if (!container) return;

    this.container = container;
    this.manager = manager;
    this.filterKey = container.dataset.filterKey;

    this.toggle = container.querySelector(".filter-toggle");
    this.options = container.querySelector(".filter-options");

    this.chiclets = chicletContainer ? new FilterChiclets(chicletContainer) : null;
    this.labelsMap = new Map();

    if (!this.manager) return;
    this.init();
  }

  init() {
    const items = this.getItemsForKey(this.filterKey);
    if (items?.length > 0) {
      this.populateOptions(items);
    }

    this.bindEvents();
    this.setCurrentSelection();
  }

  getItemsForKey(key) {
    switch (key) {
      case "guidanceFilter":
        return window.foolArchiveFilters?.guidances;
      case "serviceFilter":
        return window.foolArchiveFilters?.services;
      default:
        return [];
    }
  }

  getAllLabel() {
    return this.filterKey === "guidanceFilter"
      ? "All Guidance"
      : this.filterKey === "serviceFilter"
        ? "All Services"
        : "All";
  }

  getSingularLabel() {
    return this.filterKey === "guidanceFilter"
      ? "Guidance"
      : this.filterKey === "serviceFilter"
        ? "Service"
        : "Option";
  }

  populateOptions(items) {
    if (!this.options) return;

    this.options.innerHTML = "";
    this.labelsMap.clear();

    const allLabel = document.createElement("label");
    allLabel.innerHTML = `<input type="checkbox" value="all" checked> ${this.getAllLabel()}`;
    this.options.appendChild(allLabel);

    items.forEach((item) => {
      const value = item.slug || item.value || item.id;
      const label = item.name || item.label;

      this.labelsMap.set(value, label);

      const wrapper = document.createElement("label");
      wrapper.innerHTML = `
        <input type="checkbox" value="${value}" data-label="${label}">
        ${label}
      `;
      this.options.appendChild(wrapper);
    });
  }

  bindEvents() {
    this.toggle.addEventListener("click", () => {
      this.container.classList.toggle("open");
    });

    this.options.addEventListener("change", () => this.handleChange());

    document.addEventListener("click", (e) => {
      if (!this.container.contains(e.target)) {
        this.container.classList.remove("open");
      }
    });

    document.addEventListener("archiveFilter:changed", () => {
      this.refreshUI();
    });
  }

  getValues() {
    const currentValue = this.manager.getParam(this.filterKey);
    return currentValue ? currentValue.split(",") : [];
  }

  setCurrentSelection() {
    this.syncSelection(this.getValues());
  }

  refreshUI() {
    this.syncSelection(this.getValues());
  }

  syncSelection(values) {
    this.options.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
      cb.checked = values.includes(cb.value);
    });

    this.updateToggleLabel(values);

    if (this.chiclets) {
      const items = values.map((v) => ({
        slug: v,
        label: this.labelsMap.get(v) || v,
      }));
      this.chiclets.render(items, (slug) => this.removeValue(slug));
    }
  }

  updateToggleLabel(values) {
    if (!values.length) {
      this.toggle.textContent = this.getAllLabel();
    } else if (values.length === 1) {
      this.toggle.textContent = this.labelsMap.get(values[0]) || values[0];
    } else {
      this.toggle.textContent = `${this.getSingularLabel()}s (${values.length})`;
    }
  }

  handleChange() {
    const allCheckbox = this.options.querySelector('input[value="all"]');
    const selected = Array.from(
      this.options.querySelectorAll("input:checked")
    ).map((cb) => cb.value);

    let finalValues;

    if (selected.includes("all")) {
      this.options.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
        cb.checked = cb.value === "all";
      });
      finalValues = [];
      this.manager.setParam(this.filterKey, null);
    } else {
      if (allCheckbox) allCheckbox.checked = false;
      finalValues = selected;
      this.manager.setParam(
        this.filterKey,
        finalValues.length ? finalValues.join(",") : null
      );
    }

    this.syncSelection(finalValues);
  }

  removeValue(slug) {
    const values = this.getValues().filter((v) => v !== slug);
    this.manager.setParam(this.filterKey, values.length ? values.join(",") : null);
    this.syncSelection(values);
  }
}
